import React, { useEffect } from "react";
import "./App.css";
import "./i18n";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Signin from "./pages/Signin";
import ConfirmOutlet from "./pages/ConfirmOutlet";
import Register from "./pages/Register";
import ConfirmOTP from "./pages/ConfirmOTP";
import ConfirmVoucher from "./pages/ConfirmVoucher";
import ConfirmLoyalty from "./pages/ConfirmLoyalty";
import Profile from "./pages/Profile";
import AdminLogin from "./pages/AdminLogin";
import Dashboard from "./pages/Dashboard";
import DetailNotifications from "./pages/DetailNotifications";
import ErrorBoundary from "./ErrorBoundary";
import Withdraw from "./pages/Withdraw";
import { handleOnError } from "./middleware/Error";
import UserManagement from "./pages/UserManagement";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NotFound from "./components/NotFound";
import Settings from "./pages/Settings";
import TransactionFragment from "./fragment/TransactionFragment";
import OutletManagement from "./pages/OutletManagement";
import Notifications from "./pages/Notifications";
import { setupNotifications } from "./firebase/config";
import { useDispatch } from "react-redux";
import CashManagement from "./pages/CashManagement";
import RefundConfirmation from "./pages/RefundConfirmation";

function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    setupNotifications(dispatch);
    //eslint-disable-next-line
  }, []);
  return (
    <ErrorBoundary errorHandler={handleOnError}>
      <BrowserRouter>
        <Routes>
          <Route path="/signin" element={<Signin />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/confirm-otp" element={<ConfirmOTP />} />
          <Route path="/register" element={<Register />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/transaction" element={<TransactionFragment />} />
          <Route path="/notification" element={<Notifications />} />

          <Route path="/" element={<Home />} />
          <Route path="/user-management" element={<UserManagement />} />
          <Route path="/outlet-management" element={<OutletManagement />} />
          <Route path="/direct-cash-management" element={<CashManagement />} />
          <Route path="/confirm-voucher" element={<ConfirmVoucher />} />
          <Route path="/confirm-loyalty" element={<ConfirmLoyalty />} />
          <Route path="/confirm-refund" element={<RefundConfirmation />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/confirm-outlet" element={<ConfirmOutlet />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route
            path="/detail-notification"
            element={<DetailNotifications />}
          />
          <Route path="/withdraw" element={<Withdraw />} />
          <Route path="*" element={<NotFound />} />
          {/* <Route path="/lucky-wheel-demo" element={<LuckyWheel />} /> */}
        </Routes>
      </BrowserRouter>

      <ToastContainer />
    </ErrorBoundary>
  );
}

export default App;
